import React, { useEffect, useRef, useState, useCallback, useMemo } from "react";
import Buttons from "../../components/ui/button/Buttons";
import Select from "react-select";
import { decryptAESID } from "../../utils/Encryption";
import { useNavigate, useParams } from "react-router-dom";
import ModalGroupingTable from "./components/ModalGroupingTable";
import CostAllocation from "./components/CostAllocation";
import PageLoader from "../../components/ui/pageLoader/PageLoader";
import SwalAlert from "../../services/swalService/SwalService";
import { useLazyGetProductDetailsListByProductInformationIdQuery, useCostAlloctionBySGBPProducatInformationIdMutation, useLazyGetCertificateGroupingDetailsByIdQuery, useSendCertificateGroupingRequestForReviewMutation, useValidateCertificateNumberForAssignmentMutation, useSaveFinalCertificateAndCostAllocationMutation, useLazyGetCertificateGroupingDetailsForCommonByIdQuery, useSaveCertificateAndCostAllocationListMutation, useUpdateApplicationStatusOnPeerReviewerReturnMutation, useApproveSGBPSApplicationByFinalApproverMutation, useSaveCertificateIssuanceDetailsTaskListMutation } from "../../app/services/CertificateGrouping/certificateGroupingApi";
import { useLazyGetDropDownsForProductsAndServicesQuery } from "../../app/services/productAndService/productAndServiceApi";
import ToastService from "../../services/toastService/ToastService";
import { useDownloadCostAllocationDocMutation, useLazyGetCertificateGroupingDetailsForGWPConcreteByIdQuery, useLazyGetPeerReviewEvaluationDetailsByIdQuery, useReturnApplicationToCaseOfficerByPeerReviewerMutation, useSendApplicationToCertificationMutation } from "../../app/services/selfEvalutionReviewService/selfEvalutionReviewServiceApi";
import { useAddAuditLogForSGBPApplcation } from "../../utils/AuditLogQuery/addAuditLog";

const errorSelectStyles = {
  control: (base, state) => ({
    ...base,
    borderColor: state.selectProps.hasError ? "#dc3545" : base.borderColor,
    "&:hover": {
      borderColor: state.selectProps.hasError ? "#dc3545" : base.borderColor,
    },
  }),
};

const CertificateGroupingListGWPConcreteFinalReviewForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const applicationID = decryptAESID(id, false);
  const firstRowOriginalRef = useRef(null);
  const { success, error, confirm } = SwalAlert();
  const tickOptions = [
    { label: "1 Tick", value: 1 },
    { label: "2 Ticks", value: 2 },
    { label: "3 Ticks", value: 3 },
    { label: "4 Ticks", value: 4 },
  ];

  const [productList, setProductList] = useState([]);
  const [approverOptions, setApproverOptions] = useState([]);
  const [internalNotes, setInternalNotes] = useState("");
  const [approver, setApprover] = useState();
  const [peerReviewer, setPeerReviewer] = useState();
  const [costAllocationList, setCostAllocationList] = useState([]);
  const [isReview, setIsReview] = useState(false);
  const [isApprove, setIsApprove] = useState(false);
  const [formErrors, setFormErrors] = useState({ costAllocation: {}, peerReviewer: "", approver: "" });
  const [appNumberValues, setAppNumberValues] = useState({});
  const [peerReviewerComment, setPeerReviewerComment] = useState("")
  const [approverReviewerComment, setApproverReviewerComment] = useState("")

  const [getProductDetailsListByProductInformationId, { isLoading: productListLoading, isSuccess: productListSuccess, data: productListData }] = useLazyGetProductDetailsListByProductInformationIdQuery();
  const [getCertificateGroupingDetailsForCommonById, { isLoading: certificateGroupingDetailsLoading, isSuccess: certificateGroupingDetailsSuccess, data: certificateGroupingDetailsData }] = useLazyGetCertificateGroupingDetailsForCommonByIdQuery();
  const [productsAndServicesDropdown, { data: productsAndServicesDropDownsData, isLoading: productsAndServicesDropDownsLoading }] = useLazyGetDropDownsForProductsAndServicesQuery();
  const [validateCertificateNumberForAssignment, { isLoading: checkCernumLoading }] = useValidateCertificateNumberForAssignmentMutation();
  const [saveCertificateAndCostAllocationList, { isLoading: saveCertificateLoading, isSuccess: saveCertificateSuccess, data: saveCertificateData }] = useSaveCertificateAndCostAllocationListMutation();
  const [sendCertificateGroupingForReview, { isLoading: sendCertificateGroupingForReviewLoading, isSuccess: sendCertificateGroupingForReviewSuccess, data: sendCertificateGroupingForReviewData }] = useSendCertificateGroupingRequestForReviewMutation();
  const [sendFinalCertificateAndCostAllocation, { data: sendFinalCertificateAndCostAllocationData }] = useSaveFinalCertificateAndCostAllocationMutation();
  const [getPeerReviewEvaluationDetailsById, { isLoading: getPeerReviewEvaluationDetailsByIdLoading, isSuccess: getPeerReviewEvaluationDetailsByIdSuccess, data: getPeerReviewEvaluationDetailsByIdData, },] = useLazyGetPeerReviewEvaluationDetailsByIdQuery();
  const [returnToCaseOfficer, { isLoading: returnToCaseOfficeLoading, isSuccess: returnToCaseOfficerSuccess, data: returnToCaseOfficerData, },] = useReturnApplicationToCaseOfficerByPeerReviewerMutation();
  const [updateApplicationStatusOnPeerReviewerReturn, { isLoading: updateStatusOnReturnLoading, isSuccess: updateStatusOnReturnLoadingSuccess, data: updateStatusOnReturnLoadingData }] = useUpdateApplicationStatusOnPeerReviewerReturnMutation();
  const [sendToFinalApprover, { isLoading: sendToFinalApproverLoading, isSuccess: sendToFinalApproverSuccess, data: sendToFinalApproverData, },] = useSendApplicationToCertificationMutation();
  const [approveSGBPSApplicationByFinalApprover, { isLoading: approveApplicationLoading, isSuccess: approveApplicationSuccess, data: approveApplicationData }] = useApproveSGBPSApplicationByFinalApproverMutation();
  const [GetCertificateGroupingDetailsForGWPConcrete, { isLoading: gwpConcreteDetailIsLoading, isSuccess: gwpConcreteDetailIsSuccess, data: gwpConcreteDetailData }] = useLazyGetCertificateGroupingDetailsForGWPConcreteByIdQuery();
  const [saveCertificateIssuanceDetailsTaskList, { isLoading: saveCertificateIssuanceDetailsTaskListLoading, isSuccess: saveCertificateIssuanceDetailsTaskListSuccess, data: saveCertificateIssuanceDetailsTaskListData, },] = useSaveCertificateIssuanceDetailsTaskListMutation();
  const [downloadDoc] = useDownloadCostAllocationDocMutation();
  const { addAuditLog } = useAddAuditLogForSGBPApplcation();

  const approverOptionsMemo = useMemo(() => productsAndServicesDropDownsData?.filter((item) => item.dropdownName === "Approver List")
    .map((item) => ({ value: item.id, label: item.name })) ?? []
    , [productsAndServicesDropDownsData]);

  const itemCodeOptionsMemo = useMemo(() => productsAndServicesDropDownsData
    ?.filter((item) => item.dropdownName === "Items Codes")
    .map((item) => ({ value: item.id, label: item.name })) ?? []
    , [productsAndServicesDropDownsData]
  );

  useEffect(() => {
    const container = document.querySelector(".center-container");
    if (container) {
      container.scrollTop = 0;
    }
  }, []);

  useEffect(() => {
    const editID = decryptAESID(id, false);
    if (editID > 0) {
      productsAndServicesDropdown();
      getProductDetailsListByProductInformationId(editID);
      GetCertificateGroupingDetailsForGWPConcrete(editID);
      getPeerReviewEvaluationDetailsById(editID);
    }
  }, [id]);

  useEffect(() => {
    if (!productsAndServicesDropDownsLoading && productsAndServicesDropDownsData) {
      setApproverOptions(approverOptionsMemo);
    }
  }, [productsAndServicesDropDownsLoading, productsAndServicesDropDownsData, approverOptionsMemo]);

  useEffect(() => {
    if (!productListLoading && productListSuccess && productListData) {
      setProductList(productListData);
      const list = Array.isArray(productListData) ? productListData : productListData?.data || [];
      firstRowOriginalRef.current = list.length > 0 ? list[0].applicationNumber : null;

      //  try
      const initialApp = {};
      productListData?.forEach((item) => { initialApp[item.sgbpProductId] = item.applicationNumber ?? ""; });
      setAppNumberValues(initialApp);

    }
  }, [productListLoading, productListSuccess, productListData]);

  useEffect(() => {
    if (productList && productList.length > 0) {
      const list = Array.isArray(productList) ? productList : productList?.data || [];

      setCostAllocationList((prevRows) =>
        buildCostAllocationRows(list, itemCodeOptionsMemo, prevRows)
      );
    }
  }, [productList, itemCodeOptionsMemo]);

  //  get api 
  useEffect(() => {
    if (!gwpConcreteDetailIsLoading && gwpConcreteDetailIsSuccess && gwpConcreteDetailData && productListData) {
      const list = gwpConcreteDetailData?.getCertificateAndCostAllocationList;
      setIsApprove(gwpConcreteDetailData?.statusId == 8);
      const peerReviewerOption = approverOptionsMemo?.find((item) => item.value === gwpConcreteDetailData?.peerReviewerId);
      const approverOption = approverOptionsMemo?.find((item) => item.value === gwpConcreteDetailData?.approverId);
      setPeerReviewer(peerReviewerOption || null);
      setApprover(approverOption || null);
      setInternalNotes(gwpConcreteDetailData?.commentFromCaseOfficer || "");
      const rows = buildCostAllocationRows(productListData, itemCodeOptionsMemo);
      if (list?.length > 0) {
        rows.forEach((row) => {
          let certificateNumber = row.label;
          let prefix = 0;
          const lastSlashIndex = row.label.lastIndexOf("/");
          if (lastSlashIndex !== -1) {
            certificateNumber = row.label.substring(0, lastSlashIndex);
            prefix = row.label.substring(lastSlashIndex + 1);
          }
          const existingAllocation = list.find((x) => {
            const [xCertificateNumber, xPrefix = 0] = x.certificateNumber.split("/");
            return (xCertificateNumber === certificateNumber && Number(xPrefix) === Number(prefix || 0));
          });
          row.value = existingAllocation ? itemCodeOptionsMemo?.find((i) => i.value === existingAllocation.itemCode) ?? null : null;
          row.tickValue = existingAllocation ? tickOptions?.find((t) => t.value === existingAllocation.tickRating) ?? null : null;
          row.sgbpCertificateGroupingId = existingAllocation ? existingAllocation.sgbpCertificateGroupingId : 0;
          row.certificateFileName = existingAllocation ? (existingAllocation.costAllocFileName ?? existingAllocation.fileName ?? null) : null;
          row.certificateFilePath = existingAllocation ? (existingAllocation.costAllocFilePath ?? existingAllocation.filePath ?? null) : null;
        });
      }
      setCostAllocationList(rows);
    }
  }, [gwpConcreteDetailIsLoading, gwpConcreteDetailIsSuccess, gwpConcreteDetailData, productListData, itemCodeOptionsMemo, approverOptionsMemo]);

  useEffect(() => {
    if (!saveCertificateLoading && saveCertificateData && saveCertificateSuccess) {
      if (saveCertificateData?.hasError) {
        ToastService.error(saveCertificateData?.errorMessage);
      }
      else if (!isReview) {
        success("Certificate Grouping Request Updated Successfully!");
      }
      setIsReview(false);
    }
  }, [saveCertificateLoading, saveCertificateData, saveCertificateSuccess]);

  useEffect(() => {
    if (!sendCertificateGroupingForReviewLoading && sendCertificateGroupingForReviewSuccess && sendCertificateGroupingForReviewData) {
      if (!sendCertificateGroupingForReviewData.hasError) {
        ToastService.success("Review Request sent successfully");
        handleFinalCostAllocation();
        handleSave();
        handleBack();
      } else {
        ToastService.error(sendCertificateGroupingForReviewData.errorMessage);
      }
    }
  }, [sendCertificateGroupingForReviewLoading, sendCertificateGroupingForReviewSuccess, sendCertificateGroupingForReviewData]);

  useEffect(() => {
    if (!returnToCaseOfficeLoading && returnToCaseOfficerSuccess && returnToCaseOfficerData) {
      if (!returnToCaseOfficerData.hasError) {
        ToastService.success("Application Returned to Case Officer");
        addAuditLog({ SGBPSApplicationId: applicationID, AuditLogDescription: "SGBS Application Returned to Case Officer by Final Approver", TriggredTimeStatusId: gwpConcreteDetailData?.statusId });
        handleBack();
      } else {
        ToastService.error(returnToCaseOfficerData.errorMessage);
      }
    }
  }, [returnToCaseOfficeLoading, returnToCaseOfficerSuccess, returnToCaseOfficerData]);

  const buildCostAllocationRows = (list, itemCodes, existingRows = []) => {
    const uniqueMap = new Map();
    list.forEach((item) => {
      const certNumber = item.applicationNumber;
      const certPrefix = item.certPrefix;
      const key = certPrefix ? `${certNumber}/${certPrefix}` : certNumber;
      if (!uniqueMap.has(key)) {
        uniqueMap.set(key, true);
      }
    });

    return Array.from(uniqueMap.keys()).map((label, index) => {
      const existingExact = existingRows?.find((row) => row.label === label);
      const existingByIndex = existingRows?.[index];

      return {
        id: index + 1,
        label,
        options: itemCodes,
        value: existingExact ? existingExact.value : null,
        tickValue: existingExact ? existingExact.tickValue : null, // <-- added
        sgbpCertificateGroupingId: existingExact?.sgbpCertificateGroupingId ?? existingByIndex?.sgbpCertificateGroupingId ?? 0,
        certificateFileName: existingExact?.certificateFileName ?? existingByIndex?.certificateFileName ?? null,
        certificateFilePath: existingExact?.certificateFilePath ?? existingByIndex?.certificateFilePath ?? null,
        tickOptions: tickOptions
      };
    });
  };
  useEffect(() => {
    if (!getPeerReviewEvaluationDetailsByIdLoading && getPeerReviewEvaluationDetailsByIdSuccess && getPeerReviewEvaluationDetailsByIdData) {
      setPeerReviewerComment(getPeerReviewEvaluationDetailsByIdData?.peerReviewerComment)
      setApproverReviewerComment(getPeerReviewEvaluationDetailsByIdData?.finalApproverComment)
    }
  }, [getPeerReviewEvaluationDetailsByIdLoading, getPeerReviewEvaluationDetailsByIdSuccess, getPeerReviewEvaluationDetailsByIdData]);

  useEffect(() => {
    if (!sendToFinalApproverLoading && sendToFinalApproverSuccess && sendToFinalApproverData) {
      if (!sendToFinalApproverData.hasError) {
        ToastService.success("Application Sent to Final Approver Successfully");
        navigate("/viewApplicationTaskList")
      } else {
        ToastService.error(sendToFinalApproverData.errorMessage);
      }
    }
  }, [sendToFinalApproverLoading, sendToFinalApproverSuccess, sendToFinalApproverData]);

  useEffect(() => {
    if (!approveApplicationLoading && approveApplicationSuccess && approveApplicationData) {
      ToastService.success("Application has been approved successfully");
      addAuditLog({ SGBPSApplicationId: applicationID, AuditLogDescription: "SGBS Application Approved by Final Approver", TriggredTimeStatusId: gwpConcreteDetailData?.statusId });
      navigate("/viewApplicationTaskList");
    }
  }, [approveApplicationLoading, approveApplicationSuccess, approveApplicationData]);

  const handleReturn = () => {
    confirm('Return?', 'Are you sure you want to return?', 'Return', 'Cancel').then((confirmed) => {
      if (confirmed) {
        handleReturnApplication();
      }
    });
  };

  const handleReturnApplication = () => {
    let req = {}
    req.sGBPProductInformationId = decryptAESID(id);
    req.peerReviewerComment = peerReviewerComment
    req.FinalApproverComment = approverReviewerComment
    if (req) {
      // handleSave();
      returnToCaseOfficer(req)
      updateApplicationStatusOnPeerReviewerReturn({ SGBPProductInformationId: decryptAESID(id) });
    }
  };

  const handleSendToFinalApprover = () => {
    let req = { SGBPProductInformationId: decryptAESID(id), FinalApproverComment: approverReviewerComment }

    if (req) {
      approveSGBPSApplicationByFinalApprover(req);
    }
  };

  const handleCostAllocationChange = useCallback((rowId, selectedOption) => {
    setCostAllocationList((prevRows) =>
      prevRows.map((row) => (row.id === rowId ? { ...row, value: selectedOption ?? null } : row))
    );
    setFormErrors((prev) => {
      if (!prev.costAllocation[rowId]?.itemCode) return prev;
      const nextRow = { ...prev.costAllocation[rowId] };
      delete nextRow.itemCode;
      const nextCostAllocation = { ...prev.costAllocation };
      if (Object.keys(nextRow).length > 0) {
        nextCostAllocation[rowId] = nextRow;
      } else {
        delete nextCostAllocation[rowId];
      }
      return { ...prev, costAllocation: nextCostAllocation };
    });
  }, []);

  const handleTickRatingChange = useCallback((rowId, selectedOption) => {
    setCostAllocationList((prevRows) =>
      prevRows.map((row) => (row.id === rowId ? { ...row, tickValue: selectedOption ?? null } : row))
    );
    setFormErrors((prev) => {
      if (!prev.costAllocation[rowId]?.tickRating) return prev;
      const nextRow = { ...prev.costAllocation[rowId] };
      delete nextRow.tickRating;
      const nextCostAllocation = { ...prev.costAllocation };
      if (Object.keys(nextRow).length > 0) {
        nextCostAllocation[rowId] = nextRow;
      } else {
        delete nextCostAllocation[rowId];
      }
      return { ...prev, costAllocation: nextCostAllocation };
    });
  }, []);

  const handleCertificateFileUpload = useCallback((rowId, file) => {

    setCostAllocationList((prevRows) =>
      prevRows.map((row) =>
        row.id === rowId
          ? { ...row, certificateFile: file, certificateFileName: file.name }
          : row
      )
    );
    setFormErrors((prev) => {
      if (!prev.costAllocation[rowId]?.file) return prev;
      const nextRow = { ...prev.costAllocation[rowId] };
      delete nextRow.file;
      const nextCostAllocation = { ...prev.costAllocation };
      if (Object.keys(nextRow).length > 0) {
        nextCostAllocation[rowId] = nextRow;
      } else {
        delete nextCostAllocation[rowId];
      }
      return { ...prev, costAllocation: nextCostAllocation };
    });
  }, []);

  const handleCertificateFileDelete = useCallback((rowId) => {
    // TODO: jo already-uploaded (server) file hoy to ahi delete API call karo
    setCostAllocationList((prevRows) =>
      prevRows.map((row) =>
        row.id === rowId
          ? { ...row, certificateFile: null, certificateFileName: null, certificateFilePath: null }
          : row
      )
    );
  }, []);


  const parseApplicationNumber = (value) => {
    const str = String(value ?? "");
    const match = str.match(/^([A-Za-z]+)(\d+)$/);
    if (!match) return null;

    const [, prefix, digitsPart] = match;
    return {
      prefix,
      number: parseInt(digitsPart, 10),
      width: digitsPart.length,
    };
  };
  const validateApplicationNumber = (referenceValue, newValue, apiFlage, isExisted) => {
    const referenceParsed = parseApplicationNumber(referenceValue);
    const newParsed = parseApplicationNumber(newValue);

    if (!referenceParsed || !newParsed) {
      ToastService.error("Invalid application number format.");
      return false;
    }

    // Letters prefix must never change
    if (referenceParsed.prefix !== newParsed.prefix) {
      ToastService.error("Prefix cannot be changed.");
      return false;
    }

    const diff = newParsed.number - referenceParsed.number;
    // Width must stay the same, UNLESS the number just crossed into needing
    // one more digit (e.g. 99999 -> 100000), in which case width can grow by exactly 1.
    const expectedWidthForNewNumber = String(newParsed.number).length;
    const widthGrewNaturally =
      newParsed.width === Math.max(referenceParsed.width, expectedWidthForNewNumber) &&
      newParsed.width >= referenceParsed.width;

    if (!widthGrewNaturally) {
      ToastService.error("Invalid number format — digit padding is incorrect.");
      return false;
    }

    let isRecordExisted = productListData?.filter((item) => item.applicationNumber == newValue)

    // if (diff === 0 || diff === 1) return true; // same as reference, or +1
    if (diff === 0) return true; // same as reference, or +1

    if (diff === 1) {
      if (isExisted) {
        if (isRecordExisted.length > 0) {
          return true
        } else {
          return false
        }
      }
      return true
    }
    if (diff < 0) {
      ToastService.error("This number cannot be decreased.");
      return false;
    }
    if (diff > 0) {
      if (!apiFlage) {
        return true
      }
    }

    ToastService.error("Please increase by 1 at a time — the number cannot skip.");
    return false;
  };
  const handleAppNumberChange = useCallback((id, value) => {
    setAppNumberValues((prev) => ({ ...prev, [id]: value }));
  }, []);

  const handleCertificateFileDownload = useCallback(
    async (row) => {
      if (!row?.certificateFileName || !row?.certificateFilePath) {
        ToastService.error("No file available to download.");
        return;
      }
      try {
        const req = {
          SGBPCertificateGroupingId: row?.sgbpCertificateGroupingId,
          Type: row?.certificateFileName.split(".").pop(),
          Path: row?.certificateFilePath,
        };
        const filePath = row?.certificateFilePath;
        const fileExt = filePath?.match(/\.[^.]+$/)?.[0];
        const blob = await downloadDoc(req).unwrap();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = filePath?.replace(/^UploadCostAllocationDoc[\\/]/i, "")?.split(/[\\/]/).pop() || `resource${fileExt || ""}`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (err) {
        ToastService.error("File not found");
      }
    },
    [downloadDoc, isApprove]
  );

  const handleApplicationNumberBlur = useCallback(async (id, value) => {
    try {
      const response = await validateCertificateNumberForAssignment({ CertificateNumber: value, }).unwrap();
      let { isCertificateNumberAssigned, nextCertificateSequenceNumber, isExisted } = response;
      const newParsed = parseApplicationNumber(nextCertificateSequenceNumber);
      const index = productList.findIndex((item) => item.sgbpProductId === id);
      const oldValue = productListData?.filter((item) => item.sgbpProductId === id);
      if (value == oldValue[0]?.applicationNumber) {
        return true;
      }
      if (index === -1) return false;

      const current = productList[index];
      const ownParsed = parseApplicationNumber(current.applicationNumber);
      if (!ownParsed) {
        ToastService.error("Invalid application number format.");
        return false;
      }
      const referenceValue = index === 0 ? (firstRowOriginalRef.current ?? current.applicationNumber) : productList[index - 1].applicationNumber;
      const isValid = validateApplicationNumber(referenceValue, value, isCertificateNumberAssigned, isExisted);
      if (!isValid) return false;
      // ---- API call on blur ----
      if (response?.hasError) {
        ToastService.error(response.errorMessage || "Certificate number already assigned or invalid.");
        return false;
      }
    } catch (err) {
      console.log(err);
      ToastService.error("Something went wrong while validating certificate number.");
      return false;
    }
    // ---------------------------

    setProductList((prev) =>
      prev.map((item) => (item.sgbpProductId === id ? { ...item, applicationNumber: value } : item))
    );
    return true;
  }, [productList, validateCertificateNumberForAssignment]);

  const handleProductChange = useCallback((id, field, value) => {
    setProductList((prev) =>
      prev.map((item) => (item.sgbpProductId === id ? { ...item, [field]: value } : item))
    );
  }, []);

  const validateForm = useCallback(() => {
    const errors = { costAllocation: {}, peerReviewer: "", approver: "" };
    let firstErrorMessage = "";
    costAllocationList.forEach((row) => {
      const rowError = {};
      if (!row.value) {
        rowError.itemCode = "Item Code is required.";
        if (!firstErrorMessage) firstErrorMessage = `Please select Item Code for "${row.label}".`;
      }
      if (!row.tickValue) {
        rowError.tickRating = "Tick Rating is required.";
        if (!firstErrorMessage) firstErrorMessage = `Please select Tick Rating for "${row.label}".`;
      }
      if (!row.certificateFileName) {                              
        rowError.file = "Certificate file is required.";
        if (!firstErrorMessage) firstErrorMessage = `Please upload Certificate file for "${row.label}".`;
      }
      if (Object.keys(rowError).length > 0) {
        errors.costAllocation[row.id] = rowError;
      }
    });
    if (!peerReviewer) {
      errors.peerReviewer = "Peer Reviewer is required.";
      if (!firstErrorMessage) firstErrorMessage = "Please select Peer Reviewer.";
    }

    if (!approver) {
      errors.approver = "Approver is required.";
      if (!firstErrorMessage) firstErrorMessage = "Please select Approver.";
    }

    setFormErrors(errors);

    if (firstErrorMessage) {
      error(firstErrorMessage);
      return false;
    }
    return true;
  }, [costAllocationList, peerReviewer, approver]);

  // submit
  const handleSave = useCallback(() => {
    if (!validateForm()) return;
    const applicationId = decryptAESID(id?.toString(), false);

    const req = {
      Comments: internalNotes,
      PeerReviewerId: peerReviewer?.value,
      ApproverId: approver?.value,
      SGBPSApplicationId: applicationId,

      CertificateAndCostAllocationRequestListRequest: costAllocationList.map((row) => {
        const [certificateNumber, certPrefix] = row.label.split("/");

        return {
          SGBPSApplicationId: applicationId,
          ItemCode: row.value?.value,
          CertificateNumber: certificateNumber + (certPrefix ? `/${certPrefix}` : ""),
          TicktRating: row.tickValue?.value ?? null,
        };
      }),

      ModelGroupingCommonListRequest: productList.map(
        ({ rating, certPrefix, sgbpProductId, applicationNumber }) => ({
          SgbpProductId: sgbpProductId,
          Rating: rating !== undefined && rating !== null && rating !== "" ? Number(rating) : null,
          CertPrefix: Number(certPrefix) === 0 ? null : Number(certPrefix),
          CertificateNumber: String(applicationNumber),
        })
      ),
    };
    saveCertificateAndCostAllocationList(req);
  }, [validateForm, id, internalNotes, peerReviewer, approver, costAllocationList, productList, saveCertificateAndCostAllocationList]);


  const handleFinalCostAllocation = useCallback(() => {
    if (!validateForm()) return;
    const applicationId = decryptAESID(id?.toString(), false);


    const req = {
      sGBPSApplicationId: applicationId,
      finalCostAllocationRequestListRequest: costAllocationList.map((row) => {
        const [certificateNumber, certPrefix] = row.label.split("/");

        return {
          itemCode: row.value?.value,
          certificateNumber: certificateNumber + (certPrefix ? `/${certPrefix}` : ""),
          finalCertificateAndCostAllocationId: row?.finalCertificateAndCostAllocationId ?? 0,
        };
      })
    };
    sendFinalCertificateAndCostAllocation(req);
    // saveCertificateAndCostAllocationList 
  }, [validateForm, id, internalNotes, peerReviewer, approver, costAllocationList, productList]);



  const handleReviewRequest = useCallback(() => {
    if (!validateForm()) return;
    setIsReview(true);
    const req = { sGBPProductInformationId: decryptAESID(id) };
    sendCertificateGroupingForReview(req);
  }, [validateForm, id, sendCertificateGroupingForReview]);

  const handleBack = () => {
    navigate("/viewApplicationTaskList");
  };

  const handlePeerReviewerChange = useCallback((selected) => {
    setPeerReviewer(selected);
    setFormErrors((prev) => (prev.peerReviewer ? { ...prev, peerReviewer: "" } : prev));
  }, []);

  const handleApproverChange = useCallback((selected) => {
    setApprover(selected);
    setFormErrors((prev) => (prev.approver ? { ...prev, approver: "" } : prev));
  }, []);

  const handlePeerReviewerCommentChange = (e) => {
    setPeerReviewerComment(e.target.value);
  };

  const handleApprovalChange = (e) => {
    setApproverReviewerComment(e.target.value);
  }

  const handleCertificateAssuance = () => {
    const applicationId = decryptAESID(id?.toString(), false);
    const req = {
      SGBPSApplicationId: applicationId,
      CertificateNumber: costAllocationList.map((row) => {
        const [certificateNumber, certPrefix] = row.label.split("/");
        return certificateNumber + (certPrefix ? `/${certPrefix}` : "");
      }),
      SGBPCertificateGroupingId: costAllocationList.map((row) => row?.sgbpCertificateGroupingId),
      StatusId: 9,
      PaymentStatus: "Pending",
    };
    saveCertificateIssuanceDetailsTaskList(req);
  }

  const isPageLoading = productsAndServicesDropDownsLoading || productListLoading || gwpConcreteDetailIsLoading;



  return (
    <div className="certificate-grouping-list-page">
      <div className="crud-requirement-list">
        <div className="corporate-member-list">

          {/* Model Grouping Section */}
          <div className="table-title mt-2">
            <h3>Model Grouping</h3>
          </div>
          <ModalGroupingTable
            data={productList}
            onChange={handleProductChange}
            onApplicationNumberBlur={handleApplicationNumberBlur}
            isDisabled={isApprove || true}
          />

          {/* Certificate and Cost Allocation Section */}
          <div className="table-title mt-4">
            <h3>Certificate and Cost Allocation</h3>
          </div>
          <CostAllocation
            rows={costAllocationList}
            // onChange={handleCostAllocationChange}
            // onTickChange={handleTickRatingChange}
            // onFileUpload={handleCertificateFileUpload}
            // onFileDelete={handleCertificateFileDelete}
            onFileDownload={handleCertificateFileDownload}
            errors={formErrors.costAllocation}
            isDisabled={isApprove || true}
          />
          {/* Internal Notes Section */}
          <div className="table-title mt-5 mb-4">
            <h3>Internal Notes</h3>
          </div>
          <div className="mt-2">
            <label className="form-label">Comments from Case Officer</label>
            <textarea
              className="form-control mt-1"
              rows="4"
              value={internalNotes}
              onChange={(e) => setInternalNotes(e.target.value)}
              disabled
            ></textarea>
          </div>
          <div className="mt-2">
            <label className="form-label">Peer Reviewer Comment</label>
            <textarea
              className="form-control mt-1"
              rows="4"
              value={peerReviewerComment}
              disabled
              onChange={handlePeerReviewerCommentChange}
              maxLength={200}
            ></textarea>
          </div>
          <div className="mt-2">
            <label className="form-label">Approver Reviewer Comment</label>
            <textarea
              className="form-control mt-1"
              rows="4"
              value={approverReviewerComment}
              onChange={handleApprovalChange}
            ></textarea>
          </div>

          {/* Assign to Section */}
          <div className="table-title mt-5 mb-4">
            <h3>Assign to</h3>
          </div>
          <div className="dropdown-select-wrapper">
            <div className="d-flex align-items-center mb-4">
              <label className="form-label mb-0 w-20">Peer Reviewer</label>
              <div style={{ flex: 1 }}>
                <Select
                  className="custom-checkbox-select"
                  value={peerReviewer}
                  options={approverOptions}
                  onChange={handlePeerReviewerChange}
                  isDisabled

                />
                {formErrors.peerReviewer && (
                  <div className="field-error text-danger" style={{ fontSize: "12px", marginTop: "2px" }}>
                    {formErrors.peerReviewer}
                  </div>
                )}
              </div>
            </div>
            <div className="d-flex align-items-center">
              <label className="form-label mb-0 w-20">Approver</label>
              <div style={{ flex: 1 }}>
                <Select
                  className="custom-checkbox-select"
                  value={approver}
                  onChange={handleApproverChange}
                  options={approverOptions}
                  isDisabled
                />
                {formErrors.approver && (
                  <div className="field-error text-danger" style={{ fontSize: "12px", marginTop: "2px" }}>
                    {formErrors.approver}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="d-flex justify-content-between mt-5">
            <Buttons
              buttonText="Back"
              buttonTypeClassName="black-btn"
              onClick={handleBack}
            />

            <div className="d-flex gap-3">
              <Buttons
                buttonText="Return"
                buttonTypeClassName="reject btn"
                onClick={handleReturn}
                isLoading={returnToCaseOfficeLoading || updateStatusOnReturnLoading}
                isDisable={returnToCaseOfficeLoading || updateStatusOnReturnLoading}
              />
              <Buttons
                buttonText="Approve"
                buttonTypeClassName="success-btn"
                onClick={handleSendToFinalApprover}
                isLoading={approveApplicationLoading}
                isDisable={approveApplicationLoading}
              />
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default CertificateGroupingListGWPConcreteFinalReviewForm;
